import React from 'react';
import styled from 'styled-components';
import { graphql } from 'gatsby';
import { propsToDom } from 'core/helpers';
import { Label } from 'styles/typography';
import { RichTextEditorial } from 'components/RichText';
import { ContainerGrid } from 'components/Container';
import { Panel } from 'components/Panel';
import { Image } from 'components/Image';
import { Button } from 'components/Button';
import { rem } from 'styles/utils';
import media from 'styles/media';
import { Reveal } from 'components/Reveal';

const PushComponent = ({ id, primary, slice_type, next_slice_type, ...others }) => {
  const { background, label, image, text, button, button_text, button_color } = primary;
  const hasLabel = !!label?.text;
  const hasImage = !!image?.url;
  const hasText = !!text?.richText?.length > 0;
  const hasButton = !!button?.url && button_text;

  return (
    <Panel {...propsToDom(others)} id={slice_type} nextId={next_slice_type} background={background}>
      <ContainerGrid>
        <Left>{hasImage && <Image {...image} />}</Left>
        <Right>
          {hasLabel && <Label>{label.text}</Label>}
          {hasText && (
            <Reveal>
              <RichTextEditorial render={text.richText} />
            </Reveal>
          )}
          {hasButton && (
            <Reveal stagger={1}>
              <Button {...button} color={button_color}>
                {button_text}
              </Button>
            </Reveal>
          )}
        </Right>
      </ContainerGrid>
    </Panel>
  );
};

const Left = styled.div`
  grid-column: 1 / span 3;

  ${Image} {
    margin-left: calc(var(--margin) * -1);
    border-radius: 0 8px 8px 0;

    img {
      border-radius: inherit;
    }
  }

  ${media.mobile`
    grid-column: 1 / -1;

    ${Image} {
      margin-right: calc(var(--margin) * -1);
      border-radius: 0;
    }
  `}
`;

const Right = styled.div`
  grid-column: 5 / span 3;

  ${Label} {
    margin-top: 0;
    margin-bottom: ${rem(56)};
  }

  ${Button} {
    margin-top: ${rem(56)};
  }

  ${media.mobile`
    grid-column: 1 / -2;

    ${Label} {
      margin-bottom: calc(var(--margin) * 2);
    }

    ${Button} {
      margin-top: calc(var(--margin) * 2);
    }
  `}
`;

export const Push = styled(PushComponent)`
  ${media.mobile`
    ${ContainerGrid} {
      grid-row-gap: ${rem(56)};
    }
  `}
`;

export const query = graphql`
  fragment SlicePushHome on PrismicHomeDataBodyPush {
    id
    slice_type
    primary {
      background
      label {
        text
      }
      text {
        richText
      }
      button {
        url
        target
      }
      button_text
      button_color
      image {
        url
        alt
        dimensions {
          width
          height
        }
        thumbnails {
          mobile {
            url
            alt
            dimensions {
              width
              height
            }
          }
        }
      }
    }
  }

  fragment SlicePushPage on PrismicPageDataBodyPush {
    id
    slice_type
    primary {
      background
      label {
        text
      }
      text {
        richText
      }
      button {
        url
        target
      }
      button_text
      button_color
      image {
        url
        alt
        dimensions {
          width
          height
        }
        thumbnails {
          mobile {
            url
            alt
            dimensions {
              width
              height
            }
          }
        }
      }
    }
  }
`;
